// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"268":"Home","337":"Contact","789":"Saved"}[chunkId] || chunkId) + "." + {"268":"d27795a7","337":"ebc0f827","617":"570b9af8","763":"d9acafa6","789":"aa697bfb","820":"ad4c3007","887":"8cac0669"}[chunkId] + ".chunk.js";
};